import moment from 'moment';

import RentPaymentTypeEnum from '../constants/enums/RentPaymentTypeEnum';

import { isCardExpired } from './isCardExpired';

const cardTypes = [
  RentPaymentTypeEnum.CREDIT_CARD,
  RentPaymentTypeEnum.DEBIT_CARD,
  RentPaymentTypeEnum.PREPAID,
  'CARD',
];
const isCardExpiringSoon = (
  paymentMethod,
  format = 'M/YYYY',
  cutoffMonths = 3,
) => {
  if (isCardExpired(paymentMethod.expiration)) {
    return false;
  }
  if (!cardTypes.includes(paymentMethod.type) || !paymentMethod.expiration) {
    return false;
  }
  const expiresAt = moment(paymentMethod.expiration, format).endOf('month');
  const cutOff = expiresAt
    .clone()
    .subtract(cutoffMonths, 'months')
    .endOf('month');

  return moment().isBetween(cutOff, expiresAt);
};

export default isCardExpiringSoon;
